import { Instagram, ArrowUpRight } from "lucide-react";
import { Tile, useInstagramFeed, gridFor } from "./InstagramSection";
import { Reveal } from "./Motion";

export const BrandInstagram = ({ slug, label }) => {
  const feed = useInstagramFeed(slug);
  if (!feed) return null;
  const profile = feed.username ? `https://www.instagram.com/${feed.username}/` : feed.posts[0].permalink;
  return (
    <section data-testid="brand-instagram" className="mx-auto mt-24 max-w-[1600px] px-6 sm:px-10 lg:px-14">
      <Reveal className="mb-8 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#c8a97e]">Live from Instagram</p>
          <p className="mt-3 font-display text-4xl italic sm:text-5xl">{label} on Instagram</p>
        </div>
        <a href={profile} target="_blank" rel="noreferrer" data-testid="brand-instagram-follow" className="group inline-flex items-center gap-3 rounded-full border border-[#c8a97e]/60 px-5 py-3 text-[12px] uppercase tracking-[0.16em] text-[#c8a97e] transition-colors duration-300 hover:bg-[#c8a97e] hover:text-[#0a0b0d]">
          <Instagram className="h-4 w-4" /> {feed.username ? `@${feed.username}` : "Follow"}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </a>
      </Reveal>
      <div className={`grid gap-2 sm:gap-4 ${gridFor(feed.posts).cls}`}>
        {gridFor(feed.posts).list.map((p, i) => <Tile key={p.id} post={p} i={i} testid="brand-instagram-tile" />)}
      </div>
    </section>
  );
};
